module.exports = __webpack_public_path__ + "static/media/music_ban_btn.0145ab3f.svg";